import { render, staticRenderFns } from "./PendingInviteTeacher.vue?vue&type=template&id=446caf65&scoped=true&"
import script from "./PendingInviteTeacher.vue?vue&type=script&lang=js&"
export * from "./PendingInviteTeacher.vue?vue&type=script&lang=js&"
import style0 from "./PendingInviteTeacher.vue?vue&type=style&index=0&id=446caf65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446caf65",
  null
  
)

export default component.exports